import ScreenerExpressCheckout from "components/screener/v2/ScreenerExpressCheckout";
import { Badge } from "components/ui/Badge";
import classNames from "components/ui/classNames";
import { TextTooltip } from "components/ui/Tooltip";
import { LockIcon } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";

const FreeMode = () => {
  const intl = useIntl();
  return (
    <TextTooltip
      asChild={true}
      side="top"
      align="start"
      delayDuration={1000}
      contentClassName="font-bold"
      content={intl.formatMessage({
        defaultMessage:
          "No Modo Free, vários dados e recursos são limitados. Considere assinar o Fundamentei Premium para usufruir completamente.",
        id: "TexEae",
      })}
    >
      <div>
        <ScreenerExpressCheckout>
          <button
            type="button"
            className={classNames(
              "inline-flex h-8 items-center gap-x-2 rounded-lg bg-slate-600/5 pl-2 pr-1 dark:bg-rose-400/5",
              "ring-slate-600/20 ring-offset-2 hover:ring-[1.5px] dark:ring-slate-600/40 dark:ring-offset-slate-800",
            )}
          >
            <LockIcon
              aria-hidden={true}
              className="size-4 fill-gray-200 stroke-gray-800 dark:fill-transparent dark:stroke-rose-300"
              absoluteStrokeWidth={true}
              strokeWidth={2}
            />

            <Badge variant="red" className="inline-flex truncate rounded-md">
              <FormattedMessage defaultMessage="Modo Free" id="yVmeu8" />
            </Badge>
          </button>
        </ScreenerExpressCheckout>
      </div>
    </TextTooltip>
  );
};

export default FreeMode;
